module.exports = __webpack_public_path__ + "img/logo-02.0380860e.png";